import './map-viewport.css';
import { h } from 'preact';
import { useRef, useEffect } from 'preact/hooks';

import Scrollbar from 'react-scrollbars-custom';

/**
 * @param {object} props
 * @param {{ height: number }} props.mapSize
 * @param {{ width: number }} props.windowSize
 * @param {any=} props.floatingNav
 * @param {(e: Event) => void} props.handleClick
 * @param {number=} props.initialScrollLeft
 * @returns
 */
export default function MapViewport({ children, mapSize, windowSize, floatingNav, handleClick, initialScrollLeft = 0 } ) {
	const refScrollbar = useRef(null);

	useEffect(() => {
		if (refScrollbar.current) {
			refScrollbar.current.scrollerElement.scrollTo({
				left: initialScrollLeft,
				top: 0,
				behavior: 'smooth'
			});
		}
	}, [refScrollbar, initialScrollLeft]);

	return (
		<div class="map-viewport-container" onClick={handleClick}>
			{floatingNav}
			<Scrollbar ref={refScrollbar} noDefaultStyles noScrollY style={{ width: windowSize.width, height: mapSize.height }}>
				{children}
			</Scrollbar>
		</div>
	);
}
